/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * インポートしたWordファイルの画像情報
 * @export
 * @interface WordFileImage
 */
export interface WordFileImage {
    /**
     * 画像id
     * @type {string}
     * @memberof WordFileImage
     */
    id: string;
    /**
     * 表示位置
     * @type {string}
     * @memberof WordFileImage
     */
    position: WordFileImagePositionEnum;
    /**
     * 画像幅(px)
     * @type {number}
     * @memberof WordFileImage
     */
    width: number;
    /**
     * 画像高さ(px)
     * @type {number}
     * @memberof WordFileImage
     */
    height: number;
}

/**
* @export
* @enum {string}
*/
export enum WordFileImagePositionEnum {
    Center = 'center',
    AlignRight = 'align_right',
    AlignLeft = 'align_left',
    FloatRight = 'float_right',
    FloatLeft = 'float_left'
}

export function WordFileImageFromJSON(json: any): WordFileImage {
    return WordFileImageFromJSONTyped(json, false);
}

export function WordFileImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): WordFileImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'position': json['position'],
        'width': json['width'],
        'height': json['height'],
    };
}

export function WordFileImageToJSON(value?: WordFileImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'position': value.position,
        'width': value.width,
        'height': value.height,
    };
}

